import {RestResource} from '../rest'

import qs from 'qs'

import { WORK_ORDER_SERVER } from '../server'
import {athubAxios} from "../../util/athub-axios";

const jobTask = new RestResource({server: WORK_ORDER_SERVER, resource: 'eamJobtask'});

jobTask._maxTaskSequenceUrl = [jobTask.server, jobTask.resource, 'maxTaskSequence'].join('/');
jobTask.getMaxTaskSequence = function(jobPlanId, jobPlanSceneId, athubConfig) {
  let urlParamsString = qs.stringify({
    jobPlanId: jobPlanId,
    jobPlanSceneId: jobPlanSceneId,
  });
  return athubAxios.get(jobTask._maxTaskSequenceUrl + `?${urlParamsString}`, athubConfig);
};

export default jobTask;